import "../../exam/components/SectionTabs.css";
import Sidebar from "../../../../shared/components/Sidebar/Sidebar";
import ExerciseQuestionGrid from "./ExerciseQuestionGrid";
import ExerciseQuestionLegend from "./ExerciseQuestionLegend";

const SIDEBAR_WIDTH = 400;

const ExerciseSectionTabs = ({
  sections = [],
  activeSection,
  onSectionChange,
  questions = [],
  currentIndex = 0,
  stats,
  onSelectQuestion,
}) => {
  return (
    <div className="section-tabs-wrapper">
      <div className="section-tabs">
        <div className="tabs-left">
          {sections.map((section) => (
            <div
              key={section}
              className={`tab-item ${
                activeSection === section ? "active" : ""
              }`}
              onClick={() => onSectionChange?.(section)}
            >
              {section}
            </div>
          ))}
        </div>
      </div>

      <Sidebar
        width={`${SIDEBAR_WIDTH}px`}
        position="right"
        color="#000"
        padding="20px"
        boxShadow="-2px 0px 8px rgba(0,0,0,0.15)"
        offsetTop={90}
      >
        <ExerciseQuestionLegend stats={stats} />
        <ExerciseQuestionGrid
          questions={questions}
          currentIndex={currentIndex}
          onSelect={onSelectQuestion}
        />
      </Sidebar>
    </div>
  );
};

export default ExerciseSectionTabs;
